// Single source of truth for the eight community pathways on the landing page
// and the signup interest selector. Used by Landing.jsx, Register.jsx, Profile.jsx,
// and the ComingSoon placeholder pages.
import { HandHeart, Briefcase, HeartHandshake, Church, Music2, Calendar, Users, BookOpen } from "lucide-react";

export const PATHWAYS = [
  {
    key: "join",
    label: "Join Free",
    emoji: "🙏",
    icon: HandHeart,
    blurb: "Become part of the family — no cost to belong.",
    href: "/register",
    available: true,
    interest: false, // not a selectable interest, it's the action itself
  },
  {
    key: "business",
    label: "Browse Businesses",
    emoji: "💼",
    icon: Briefcase,
    blurb: "Faith-led businesses you can support.",
    href: "/businesses",
    available: false,
    interest: true,
  },
  {
    key: "help",
    label: "Find Help",
    emoji: "❤️",
    icon: HeartHandshake,
    blurb: "Reach out when you need support — financial, emotional, or spiritual.",
    href: "/find-help",
    available: false,
    interest: true,
  },
  {
    key: "churches",
    label: "Churches",
    emoji: "⛪",
    icon: Church,
    blurb: "Find a local body of believers to worship with.",
    href: "/churches",
    available: false,
    interest: true,
  },
  {
    key: "music",
    label: "Gospel Music",
    emoji: "🎵",
    icon: Music2,
    blurb: "Worship, inspire, and share songs that lift the soul.",
    href: "/music",
    available: true,
    interest: true,
  },
  {
    key: "events",
    label: "Events",
    emoji: "📅",
    icon: Calendar,
    blurb: "Prayer nights, fasts, baptisms, and gatherings.",
    href: "/events",
    available: true,
    interest: true,
  },
  {
    key: "volunteer",
    label: "Volunteer",
    emoji: "🤝",
    icon: Users,
    blurb: "Serve where you're needed — every gift counts.",
    href: "/volunteer",
    available: true,
    interest: true,
  },
  {
    key: "prayer",
    label: "Prayer Wall",
    emoji: "📖",
    icon: BookOpen,
    blurb: "Lift requests, intercede for others, mark answered prayers.",
    href: "/groups",
    available: true,
    interest: true,
  },
];

// Interests presented to the user during signup
export const SIGNUP_INTERESTS = PATHWAYS.filter((p) => p.interest);
